export default __webpack_public_path__ + "3662b311d875edd627ebacb0bc809d0e.png";